if(typeof tlFreeGiftBlockIsRestricted !== "undefined"){
  const overwriteSalepify = () => {
    if (window.tlFreeGiftBlock) {
      const cloneFunc = window.tlFreeGiftBlock.applyDiscounts;
      window.tlFreeGiftBlock.applyDiscounts = async (discounts) => {
        const resDiscount = await cloneFunc(discounts);
  
        const cartDataReq = await fetch("/cart.js");
        const cartDataRes = await cartDataReq.json();
  
        const listDiscount = cartDataRes.discount_codes.map(discount => discount.code);
        const discountCodes = listDiscount.join(",")
        localStorage.setItem("minimog-discount-code", discountCodes);
        const inputDcEle = document.querySelector('.m-cart-addon__content input[name="discount"]');
        if(inputDcEle){
          inputDcEle.value = discountCodes
        }
        return resDiscount;
      }
      clearInterval(intervalId);
    }
  }
   
  const intervalId = setInterval(overwriteSalepify, 50);
  setTimeout(() => {
    clearInterval(intervalId);
  }, 3000);
}

if(typeof tlAdvancedFGIsRestricted !== "undefined"){
  const overwriteSalepify = () => {
    if (window.tlAdvancedFreeGift) {
      const cloneFunc = window.tlAdvancedFreeGift.applyDiscounts;
      window.tlAdvancedFreeGift.applyDiscounts = async (discounts) => {
        const resDiscount = await cloneFunc(discounts);
  
        const cartDataReq = await fetch("/cart.js");
        const cartDataRes = await cartDataReq.json();
  
        const listDiscount = cartDataRes.discount_codes.map(discount => discount.code);
        const discountCodes = listDiscount.join(",")
        localStorage.setItem("minimog-discount-code", discountCodes);
        const inputDcEle = document.querySelector('.m-cart-addon__content input[name="discount"]');
        if(inputDcEle){
          inputDcEle.value = discountCodes
        }
        return resDiscount;
      }
      clearInterval(intervalId);
    }
  }
   
  const intervalId = setInterval(overwriteSalepify, 50);
  setTimeout(() => {
    clearInterval(intervalId);
  }, 3000);
}
  
  